import React, { useState, useEffect } from 'react';
import './Enquirymodal.css';
import { CONFIG } from '../data';

function EnquiryModal() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '', event: '', guests: '', date: '', message: '' });
  const [ok, setOk] = useState(false);

  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  // Close on Escape key
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  const ch = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const sub = (e) => {
    e.preventDefault();
    const msg = [
      `Hello ${CONFIG.businessName}!`, ``,
      `Name: ${form.name}`,
      `Phone: ${form.phone}`,
      `Event: ${form.event || 'Not specified'}`,
      `Guests: ${form.guests || 'Not specified'}`,
      `Date: ${form.date || 'Not specified'}`,
      `Message: ${form.message || '-'}`
    ].join('\n');
    window.open(`https://wa.me/${CONFIG.whatsappNumber}?text=${encodeURIComponent(msg)}`, '_blank');
    setOk(true);
    setTimeout(() => { setOk(false); setOpen(false); setForm({ name: '', phone: '', event: '', guests: '', date: '', message: '' }); }, 4000);
  };

  return (
    <>
      {/* ── Floating Enquiry Button ── */}
      <button
        className="enq-fab"
        onClick={() => setOpen(true)}
        aria-label="Quick Enquiry"
      >
        <span className="enq-fab-icon">📋</span>
        <span className="enq-fab-label">Quick Enquiry</span>
      </button>

      {/* ── Modal Backdrop ── */}
      {open && (
        <div className="enq-backdrop" onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}>
          <div className="enq-modal" role="dialog" aria-modal="true">

            {/* Top accent bar */}
            <div className="enq-modal-bar" />

            {/* Close button */}
            <button className="enq-close" onClick={() => setOpen(false)} aria-label="Close">✕</button>

            {ok ? (
              <div className="enq-ok">
                <span>🎉</span>
                <h3>Opening WhatsApp!</h3>
                <p>Your booking details are sent. We'll respond within the hour!</p>
              </div>
            ) : (
              <>
                <h3 className="enq-title">Quick <em>Enquiry</em></h3>
                <p className="enq-sub">We'll craft a custom menu just for you.</p>

                <form onSubmit={sub} className="enq-form">
                  <div className="enq-row">
                    <div className="enq-grp">
                      <label>Your Name *</label>
                      <input type="text" name="name" required value={form.name} onChange={ch} placeholder="Enter your name" />
                    </div>
                    <div className="enq-grp">
                      <label>Phone *</label>
                      <input type="tel" name="phone" required value={form.phone} onChange={ch} placeholder="+91 XXXXX XXXXX" />
                    </div>
                  </div>

                  <div className="enq-row">
                    <div className="enq-grp">
                      <label>Event Type</label>
                      <select name="event" value={form.event} onChange={ch}>
                        <option value="">Select type</option>
                        <option>Wedding</option>
                        <option>Corporate Event</option>
                        <option>Birthday Party</option>
                        <option>Religious Function</option>
                        <option>Other</option>
                      </select>
                    </div>
                    <div className="enq-grp">
                      <label>No. of Guests</label>
                      <input type="number" name="guests" value={form.guests} onChange={ch} placeholder="Approx. count" min="1" />
                    </div>
                  </div>

                  <div className="enq-grp">
                    <label>Event Date</label>
                    <input type="date" name="date" value={form.date} onChange={ch} />
                  </div>

                  <div className="enq-grp">
                    <label>Message / Special Requirements</label>
                    <textarea name="message" rows="3" value={form.message} onChange={ch} placeholder="Dietary preferences, special requests..." />
                  </div>

                  <button type="submit" className="btn-main wide">📲 Send via WhatsApp</button>
                  <p className="enq-note">Details sent directly to our WhatsApp for faster response</p>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default EnquiryModal;